'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jsonify = exports.initNetwork = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

require('isomorphic-fetch');

var _errors = require('./errors');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initNetwork = exports.initNetwork = function initNetwork(_ref) {
  var base = _ref.base,
      transform = _ref.transform,
      logs = _ref.logs,
      session = _ref.session,
      token = _ref.token;

  var network = {};
  network.req = req({ network: network, base: base, transform: transform, logs: logs });
  network.getPnxToken = getPnxToken({ network: network });

  network.renew = renew({ network: network, session: session });
  network.request = request({ network: network, session: session, token: token });
  return network;
};

// Makes a request to the original ShareBase API getting new tokens if needed.
var req = function req(_ref2) {
  var base = _ref2.base,
      transform = _ref2.transform,
      logs = _ref2.logs;
  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(path, init) {
      var fullPath, req, resp, body;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fullPath = _url2.default.resolve(base, path);

              logs.push(fullPath);
              req = transform(new Request(fullPath, init));
              _context.t0 = _errors.throwOnFail;
              _context.next = 6;
              return fetch(req);

            case 6:
              _context.t1 = _context.sent;
              _context.next = 9;
              return (0, _context.t0)(_context.t1);

            case 9:
              resp = _context.sent;
              _context.next = 12;
              return resp.json();

            case 12:
              body = _context.sent;
              return _context.abrupt('return', body);

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();
};

// Makes a request to the official sharebase to create a new session and returns
// the response without updating the context session.
var getPnxToken = function getPnxToken(_ref4) {
  var network = _ref4.network;
  return function () {
    var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
      var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _utils.required)('email', 'renew');
      var password = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _utils.required)('password', 'renew');
      var inner, headers, authed;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              inner = (0, _utils.base64Encode)(email + ':' + password);
              headers = { 'Authorization': 'Basic ' + inner };
              _context2.next = 4;
              return network.req('authenticate', { headers: headers });

            case 4:
              authed = _context2.sent;
              return _context2.abrupt('return', authed);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    return function () {
      return _ref5.apply(this, arguments);
    };
  }();
};

// Renews or creates the session using the information provided. It updates
// context.session, context.sessionStore and returns the response received from
// the server along with the token to use to access the just renewed session.
var renew = function renew(_ref6) {
  var network = _ref6.network,
      session = _ref6.session;
  return function () {
    var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(email, password) {
      var store, authed, delegate, _me, me;

      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              store = session.store;
              _context3.next = 3;
              return network.getPnxToken(email, password);

            case 3:
              authed = _context3.sent;

              if (session.me) {
                _context3.next = 12;
                break;
              }

              _context3.next = 7;
              return (0, _utils.token)();

            case 7:
              delegate = _context3.sent;
              _me = { email: email, password: password };

              authed.delegate = delegate;
              store.set(delegate, _me);

              session.me = _me;

            case 12:
              me = session.me;

              me.expires = +Date.parse(authed['ExpirationDate']);
              me.authed = authed;

              // expose the delegate token
              return _context3.abrupt('return', authed);

            case 16:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, undefined);
    }));

    return function (_x5, _x6) {
      return _ref7.apply(this, arguments);
    };
  }();
};

var request = function request(context) {
  return function () {
    var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(path, init) {
      var session, _context$network, renew, req, _session$me, me, token, backendToken, timeToExpire, email, password, headers;

      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              session = context.session, _context$network = context.network, renew = _context$network.renew, req = _context$network.req;
              _session$me = session.me, me = _session$me === undefined ? (0, _utils.required)('me', 'request') : _session$me, token = session.token;
              backendToken = null;

              if (!(me === null)) {
                _context4.next = 7;
                break;
              }

              // a token for communicating directly with the ShareBase API was provided.
              backendToken = token;
              _context4.next = 14;
              break;

            case 7:
              // a delegate token was supplied

              // handle renewals
              timeToExpire = me.expires - Date.now();

              if (!me.renewalPromise && timeToExpire < 5 * _utils.MINUTES) {
                // renew the credentials
                email = me.email, password = me.password;


                me.renewalPromise = renew(email, password);
              }

              if (!me.renewalPromise) {
                _context4.next = 13;
                break;
              }

              _context4.next = 12;
              return me.renewalPromise;

            case 12:
              me.renewalPromise = null;

            case 13:

              backendToken = me.authed['Token'];

            case 14:

              // we have an active session with the official ShareBase, use it
              headers = { 'Authorization': 'PHOENIX-TOKEN ' + backendToken };
              _context4.next = 17;
              return req(path, mergeInits(init, { headers: headers }));

            case 17:
              return _context4.abrupt('return', _context4.sent);

            case 18:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, undefined);
    }));

    return function (_x7, _x8) {
      return _ref8.apply(this, arguments);
    };
  }();
};

// Creates a fetch init object which encodes the object as JSON and sets the
// mime type to application/json.
var jsonify = exports.jsonify = function jsonify(obj) {
  return {
    body: (0, _stringify2.default)(obj),
    headers: { 'Content-Type': 'application/json' }
  };
};

// Merges fetch initialization objects taking care to preserve headers.
var mergeInits = function mergeInits() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var definedArgs = args.filter(function (arg) {
    return arg !== undefined;
  });

  var finalObject = definedArgs.reduce(function (acc, arg) {
    return (0, _assign2.default)(acc, arg);
  }, {});

  var headers = definedArgs.map(function (init) {
    return init.headers;
  }).filter(function (e) {
    return !!e;
  });
  var finalHeaders = mergeHeaders.apply(undefined, (0, _toConsumableArray3.default)(headers));

  return (0, _extends3.default)({}, finalObject, {
    headers: finalHeaders
  });
};

// Merges a list of headers like arguments into a single Headers object.
var mergeHeaders = function mergeHeaders() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return args.reduce(function (acc, headers) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)((0, _entries2.default)(headers)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
            key = _step$value[0],
            value = _step$value[1];

        acc.append(key, value);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return acc;
  }, new Headers());
};


//////////////////
// WEBPACK FOOTER
// ./~/nice-sharebase/lib/network.js
// module id = 285
// module chunks = 0